import { useCustomerService } from '../customerService';
import { Container, PageContent } from './Common.styles';
import { BRANDING_KEY } from '~/components/branding/constants';
import useBranded from '~/components/branding/useBranded';

const PublicWrapper = ({ children }: React.PropsWithChildren) => {
  useCustomerService();
  const customBranding = useBranded(BRANDING_KEY.PUBLIC_CLASSNAME);

  return (
    <Container className={customBranding} color="$black">
      <PageContent>{children}</PageContent>
    </Container>
  );
};
export default PublicWrapper;
